import React from 'react';

interface FilterCardProps {
  icon: React.ReactNode;
  label: string;
  count: number;
  totalCount?: number;
  active: boolean;
  onClick: () => void;
  color?: 'indigo' | 'amber' | 'pink' | 'blue' | 'green' | 'purple';
}

const FilterCard: React.FC<FilterCardProps> = ({ icon, label, count, totalCount, active, onClick, color = 'indigo' }) => {
  const colorStyles = {
    indigo: 'bg-indigo-100 text-indigo-600',
    amber: 'bg-amber-100 text-amber-600',
    pink: 'bg-pink-100 text-pink-600',
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-600',
  };

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-3 p-4 rounded-xl border-2 transition-all w-full ${
        active
          ? 'border-indigo-500 bg-white shadow-md'
          : 'border-slate-200 bg-white hover:border-slate-300'
      }`}
    >
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colorStyles[color]}`}>
        {icon}
      </div>
      <div className="text-left">
        <p className="text-xs text-slate-500 font-medium">{label}</p>
        <p className="text-2xl font-bold text-slate-800">
          {count}
          {totalCount !== undefined && totalCount !== count && (
            <span className="text-sm text-slate-400 font-normal ml-1">/ {totalCount}</span>
          )}
        </p>
      </div>
    </button>
  );
};

export default FilterCard;
